import Groq from "groq-sdk";

// 删除未使用的配置
// const DEEPSEEK_API_URL = process.env.DEEPSEEK_API_URL || "https://api.deepseek.com/v1/chat/completions";

/**
 * 使用OpenRouter API进行塔罗牌解读 - 通过API路由调用
 */
export async function tarotReading_openrouter(question: string, card: string, language: string, readerType: 'kind' | 'direct', isReversed: boolean = false): Promise<{text: string, isSuitableForTarot: boolean}> {
    try {
        // 添加字符限制检查
        const MAX_CHARS = 200;
        if (question.length > MAX_CHARS) {
            return {
                text: language === '中文' 
                    ? `抱歉，您的问题太长了。为了确保塔罗牌解读的质量，请将问题控制在${MAX_CHARS}字以内。`
                    : `Sorry, your question is too long. To ensure the quality of the tarot reading, please keep your question under ${MAX_CHARS} characters.`,
                isSuitableForTarot: false
            };
        }
        console.log("isReversed", isReversed);
        // 调用API路由而不是直接使用OpenRouter API
        const response = await fetch("/api/openrouter", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                question,
                card,
                language,
                readerType,
                isReversed
            }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("API路由详细错误:", errorData);
            throw new Error(`API路由错误: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        
        // 直接使用API路由返回的结果
        return {
            text: result.text,
            isSuitableForTarot: result.isSuitableForTarot
        };
    } catch (error) {
        console.error("Error in OpenRouter API call:", error);
        throw error;
    }
}


/**
 * 使用Groq API进行塔罗牌解读 - 通过API路由调用
 */
export async function tarotReading_groq(question: string, card: string, language: string, readerType: 'kind' | 'direct', isReversed: boolean = false): Promise<{text: string, isSuitableForTarot: boolean}> {
    try {
        // 添加字符限制检查
        const MAX_CHARS = 200;
        if (question.length > MAX_CHARS) {
            return {
                text: language === '中文' 
                    ? `抱歉，您的问题太长了。为了确保塔罗牌解读的质量，请将问题控制在${MAX_CHARS}字以内。`
                    : `Sorry, your question is too long. To ensure the quality of the tarot reading, please keep your question under ${MAX_CHARS} characters.`,
                isSuitableForTarot: false
            };
        }
        console.log("isReversed", isReversed);
        // 调用API路由而不是直接使用Groq SDK
        const response = await fetch("/api/groq", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                question,
                card,
                language,
                readerType,
                isReversed
            }),
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error("API路由详细错误:", errorData);
            throw new Error(`API路由错误: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        
        // 直接使用API路由返回的结果
        return {
            text: result.text,
            isSuitableForTarot: result.isSuitableForTarot
        };
    } catch (error) {
        console.error("Error in Groq API call:", error);
        throw error;
    }
}